import { VendorBase } from './base/vendor-base';

export class Vendor extends VendorBase { }